enum Focus {
  Nutrition = "Nutrition",
  Training = "Training",
  BuildingGoodHabits = "BuildingGoodHabits",
}

const focusQuestion = {
  name: "focus",
  title: "Last question <div class='highlight'><span>{name}</span>!</div> What are you most interested in?",
  type: "radiogroup",
  choices: [
    {
      value: Focus.Nutrition,
      text: "Nutrition",
    },
    {
      value: Focus.Training,
      text: "Training",
    },
    {
      value: Focus.BuildingGoodHabits,
      text: "Building good habits",
    },
  ],
  isRequired: true,
  showOtherOption: true,
}

export {
  Focus,
  focusQuestion,
}